import React from "react"
import PageTemplate from "../components/pageTemplate"
import SEO from "../components/seo"

let About = () => (
  <PageTemplate title="About Us">
    <SEO title="About" />
    <p>
      We have adopted a continuous learning and improvement approach the the focus area to ensure that we are at the level best to serve our customers and partners. Vision and Mission must stay parallel in order to stay focus in what
      we do. We believe that focus is the key to prosper even further in 
      this business. Focus will also guarantee level of perfection and 
      quality which pre-determined the customers acceptance.
    </p>
    <br></br>
    <h4>Vision</h4>
    <p>
      To help accelerate business productivity and growth for our customers.
    </p>
    <p>
      <h4>Mission</h4>
      To create Innovative Business Productivity Solutions that rides on Industrial Revolution 4.0.
    </p>
  </PageTemplate>
)

export default About
